import { render, staticRenderFns } from "./prompt-tab.vue?vue&type=template&id=2c0a55aa"
import script from "./prompt-tab.vue?vue&type=script&lang=js"
export * from "./prompt-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports